import Resource from 'Resources/ResourceTyped';
import { SidebarCountFiltersBuilt, SidebarCountResult } from 'App/components/ListViewSidebar/Context/Helpers';

/** The ES types this endpoint can search. Omitting them searches all three. */
export type ActivityListInclude = 'activities' | 'appointments' | 'mail';
export type ActivityListIncludes = ActivityListInclude[] | string;

/**
 * For filters whose every OR branch requires an `activityType` or `isAppointment` match: a mail
 * document carries neither, so naming these two loses no rows and skips the mail index.
 */
export const ACTIVITY_AND_APPOINTMENT: ActivityListIncludes = ['activities', 'appointments'];

const asIncludes = (includes?: ActivityListIncludes): string =>
	(Array.isArray(includes) ? includes.join(',') : includes ?? '').trim();

class ActivityList extends Resource<any> {
	constructor() {
		super('search/activitylist');

		this.dateFields = ['date', 'regDate', 'modDate'];
	}

	/**
	 * `includes` narrows which types are searched; worth passing whenever the caller knows it
	 * cannot match one. A request that names none asks for all three, which keeps it on
	 * Elasticsearch since mail has no MySQL path yet.
	 */
	find(filters = {}, opts: { includes?: ActivityListIncludes } = {}) {
		const { includes, ...rest } = opts;
		const path = asIncludes(includes);
		return super.find(filters, path ? { ...rest, path } : rest);
	}

	async getListViewCounts(
		filters: Array<SidebarCountFiltersBuilt>,
		includes?: ActivityListIncludes
	): Promise<Array<SidebarCountResult>> {
		return this._postRequest('listCounts', { filters, includes: asIncludes(includes) || undefined }).then(
			({ data }) => {
				return data;
			}
		);
	}
}

const resource = new ActivityList();

export default resource;
